const state = {
  administrators: []
}

const getters = {
  administrators (state) {
    return state.administrators
  }
}

const mutations = {
  SET_ADMINISTRATORS (state, payload) {
    state.administrators = payload
  },
  DELETE_ADMINISTRATOR (state, payload) {
    state.administrators = state.administrators.filter((administrator) => {
      return administrator.id !== payload
    })
  },
  ADD_ADMINISTRATOR (state, payload) {
    state.administrators.push(payload)
  }
}

const actions = {
  DELETE_ADMINISTRATOR (context, payload) {
    context.commit('DELETE_ADMINISTRATOR', payload)
  },
  ADD_ADMINISTRATOR (context, payload) {
    context.commit('ADD_ADMINISTRATOR', payload)
  },
  SET_ADMINISTRATORS (context, payload) {
    context.commit('SET_ADMINISTRATORS', payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
